import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [3, 1],
        components: [
          [
            {
              variant: "layout",
              data: {
                type: "videoPlayToPoint",
                options: {
                  video: {
                    src: `${config.ASSETS_URL}/03/11/principle/screen-diffraction.mov`,
                  },
                  regions: [
                    {
                      id: "a",
                      start: 0,
                      end: 10,
                      label: "250 Hz",
                    },
                    {
                      id: "b",
                      start: 10,
                      end: 19,
                      label: "1000 Hz",
                    },
                  ],
                  controlsPosition: "top",
                  controlsAlign: "center",
                  hideLoopControl: true,
                  buttonsShape: "round",
                  controlsTheme: "secondary",
                },
                styles: {
                  padding: "0 15%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "In this example the sound pressure level is visualized in a room. The sound source is a loudspeaker in the center of the room. Please notice that the sound wave is propagating considering wave based effects like scattering, diffraction and wave interference. In this example the diffraction over the noise barrier is clearly visible.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
